<div class="container">
    <mat-dialog-title class="title-block">
        <h2>CREATE PARTNER GROUP</h2>
        <app-close-x-icon (click)="onClose()"></app-close-x-icon>
    </mat-dialog-title>
    <mat-dialog-content class="content-block">

        <div class="content-container">

            <mat-form-field class="partner-group-form-field">
                <mat-label>PARTNER GROUP NAME</mat-label>
                <input class="partner-group-input-field" matInput placeholder="Enter Partner Group Name"
                    [(ngModel)]="newPartnerGroupName">
            </mat-form-field>

            <div class="content">
                <h5>AVAILABLE PARTNERS</h5>

                <mat-grid-list cols="1" rowHeight="2:1" class="available-partners-list">

                    <mat-grid-tile class="checkbox-field" *ngFor="let partner of availablePartners; let i = index">
                        <section class=""
                            [ngClass]="{'selected-checkbox' : partner.selected}">
                            <mat-checkbox *ngIf="partner.partner.name.toLowerCase() != 'mibe music'" [(ngModel)]="partner.selected"></mat-checkbox>
                            <mat-checkbox *ngIf="partner.partner.name.toLowerCase() == 'mibe music'" [checked]="partner.partner.name.toLowerCase() == 'mibe music'" [disabled]="partner.partner.name.toLowerCase() == 'mibe music'"></mat-checkbox>
                            <mat-label class="checkbox-label">{{partner.partner.name}}</mat-label>
                        </section>
                    </mat-grid-tile>

                </mat-grid-list>
            </div>

        </div>

    </mat-dialog-content>


    <mat-dialog-actions class="action-block">
        <button class="add-partner-btn" mat-button (click)="addNewPartnerGroup()">CREATE GROUP</button>
        <button class="cancel-btn" mat-button (click)="onClose()">CANCEL</button>
    </mat-dialog-actions>
</div>